import React from "react";
import { Accordion } from "../../../../../../react-core/Html/Accordion";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { AlertDefinitionCategory } from "../../../../../../Wrap/Models/Domains/Threads/AlertDefinitionCategory";
import { NotificationConfiguration } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfiguration";
import { NotificationConfigurationModel } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfigurationModel";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { NotificationAction } from "../../Action/NotificationAction";

interface IExistingNotificationsProps {
    model: NotificationConfigurationModel;
    hasFirmLevelPermission: boolean;
    onSave: () => void;
    AllAdvisorSelected?:boolean;
}

interface IExistingNotificationsState {
    existingConfigurations: Array<NotificationConfiguration>;
    categoriesToDelete: Array<AlertDefinitionCategory>;
    alertDefinitionCategories: Array<AlertDefinitionCategory>;
    alertsToRemove: Array<NotificationConfiguration>;
    showErrorMsg: boolean;
}

export class ExistingNotifications extends FormComponent<IExistingNotificationsProps, IExistingNotificationsState> {
    constructor(props: IExistingNotificationsProps) {
        super(props);
        this.state = {
            existingConfigurations: props.model?.ActiveNotifications,
            categoriesToDelete: [],
            alertDefinitionCategories: props.model?.Categories,
            alertsToRemove: [],
            showErrorMsg: false,
        };
    }

    isValid() {
        const isValid = super.isValid();
        if (isValid) {
            const notificationSelected = this.state.alertsToRemove.length > 0;
            if (!notificationSelected) {
                this.setState({ showErrorMsg: true });
            }
            return notificationSelected;
        }
        return false;
    }
    private onSave() {
        if (this.isValid()) {
            const alertsToRemove = this.state.alertsToRemove;
            alertsToRemove.forEach((alert) => {
                alert.ReceiveAlert = false;
            });
            this.updateConfigurations(alertsToRemove);
        }
    }

    private updateConfigurations(configurations: Array<NotificationConfiguration>) {
        NotificationAction.updateNotificationConfiguration(configurations, () => this.props.onSave());
    }

    private displayNotificationConfigurations() {
        const { existingConfigurations, alertDefinitionCategories } = this.state;
        const tables: JSX.Element[] = [];
        if (alertDefinitionCategories) {
            alertDefinitionCategories.forEach((category) => {
                if (existingConfigurations.some((x) => x?.Category == category.Name)) {
                    tables.push(this.displayExistingNotificationCategory(category));
                }
            });
        }
        return tables;
    }  

    private displayExistingNotificationCategory(category: AlertDefinitionCategory): JSX.Element {
        const { existingConfigurations } = this.state;
        const rows = [];
        const existingAlerts = existingConfigurations?.filter((x) => x?.Category == category?.Name);
        const alertDefinitions = existingAlerts?.map((x) => x?.Alert);
        const distinctAlerst = alertDefinitions.filter((n, i) => alertDefinitions.indexOf(n) === i);
        distinctAlerst.forEach((alert) => {
            rows.push(this.displayExistingAlertDefinition(alert));
        });
        const displayRemoveAllOption = existingAlerts.some((x) => x?.Detail != "Mandatory");
        return (
            <Accordion label={category.Name} cssWrapper="accordion sl-blue not-editable" isOpen={false}>
                <table className="data-table no-sided-padding mb-0 pb-24">
                    <thead>
                        <tr>
                            <th className="cell-30">Notification</th>
                            <th className="cell-30">Notification level</th>
                            <th className="cell-30">Type</th>
                            <th className="text-right">
                                {displayRemoveAllOption && (
                                    <>
                                        Remove All
                                        <CheckboxEditor
                                            label=""
                                            cssWrapper="square-checkbox mb-0 ml-10"
                                            value={this.state.categoriesToDelete.includes(category)}
                                            onChange={(v) => {
                                                if (v) {
                                                    //remove all active config under the category
                                                    const categories = this.state.categoriesToDelete;
                                                    categories.push(category);

                                                    const toRemove = this.state.alertsToRemove;
                                                    const alerts = this.state.existingConfigurations.filter(
                                                        (x) => x?.Category == category?.Name
                                                    );
                                                    alerts.forEach((alert) => {
                                                        if (
                                                            !this.state.alertsToRemove.includes(alert) &&
                                                            alert?.Detail != "Mandatory"
                                                        ) {
                                                            toRemove.push(alert);
                                                        }
                                                    });
                                                    this.setState({
                                                        categoriesToDelete: categories,
                                                        alertsToRemove: toRemove,
                                                        showErrorMsg: false,
                                                    });
                                                } else {
                                                    let categories = this.state.categoriesToDelete;
                                                    categories = categories.filter((x) => x?.Id != category?.Id);

                                                    let toRemove = this.state.alertsToRemove;
                                                    toRemove = toRemove.filter((x) => x?.Category != category?.Name);
                                                    this.setState({
                                                        categoriesToDelete: categories,
                                                        alertsToRemove: toRemove,
                                                        showErrorMsg: false,
                                                    });
                                                }
                                            }}
                                        />
                                    </>
                                )}
                            </th>
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </Accordion>
        );
    }

    private displayExistingAlertDefinition(alertName: string): JSX.Element {
        const { AllAdvisorSelected } = this.props;
        const { existingConfigurations } = this.state;
        const alertConfigs = existingConfigurations.filter((x) => x?.Alert == alertName);

        let alertDetail = "";
        if (
            alertConfigs.length == 1 &&
            (alertConfigs[0]?.Detail == "Mandatory" || alertConfigs[0]?.Detail == "Default")
        ) {
            alertDetail = alertConfigs[0].Detail;
        } else if (alertConfigs != null && alertConfigs.length > 0 && alertConfigs[0]?.EntityType == 2 && AllAdvisorSelected) {
                alertDetail = "All advisers"   
        } else if (alertConfigs.length == 1 && alertConfigs[0]?.EntityType == 3) {
            alertDetail = "All advisers";
        } else if (alertConfigs.length == 1 && alertConfigs[0]?.EntityType == 2) {
            alertDetail = alertConfigs[0]?.Detail;
        } else if (!alertConfigs.some((x) => x?.EntityType == 3)) {
            alertDetail = "Multiple advisers";
        } else {
            alertDetail = "All advisers";
        }

        const configuration = alertConfigs[0];
        return (
            <tr>
                <td>{configuration?.Alert}</td>
                <td className="cell-30">{alertDetail}</td>
                <td className="cell-30">
                    {configuration?.NotificationType == "ImportantInformation"
                        ? "Important information"
                        : configuration?.NotificationType}
                </td>
                <td className="text-right">
                    {configuration?.Detail != "Mandatory" && (
                        <CheckboxEditor
                            label=""
                            onChange={(v) => {
                                let toRemove = this.state.alertsToRemove;
                                if (v) {
                                    toRemove = toRemove.concat(alertConfigs);
                                } else {
                                    toRemove = toRemove.filter((x) => x?.Alert != alertName);
                                }
                                this.setState({ alertsToRemove: toRemove, showErrorMsg: false });
                            }}
                            value={this.state.alertsToRemove.some((x) => x?.Alert == alertName)}
                            cssWrapper="square-checkbox mb-0 ml-10"
                        />
                    )}
                </td>
            </tr>
        );
    }

    public render(): JSX.Element {
        return (
            <div>
                {this.state.showErrorMsg && (
                    <Alert alertType={AlertType.Error} message={"Please select a notification to remove"} />
                )}
                <h2>Existing notifications</h2>
                <span>Review and manage your event notifications</span>
                <br />
                {this.displayNotificationConfigurations()}

                <button
                    className="next-button mt-5"
                    onClick={() => {
                        this.onSave();
                    }}
                >
                    <span aria-hidden="true" className="icon"></span>
                    <span className="text">Remove notification</span>
                </button>
            </div>
        );
    }
}
